export default {"src":"/_next/static/media/refer-a-friend.21d1a0d4.svg","height":138,"width":173,"blurWidth":0,"blurHeight":0};